<template>
    <div
        :id="id"
        :aria-labelledby="id"
        class="modal fade add-to-cart-popin-cds"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
        data-ob1-component="Popin"
    >
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div>
                    <!--/* header */-->
                    <div class="modal-header">
                        <button
                            type="button"
                            class="btn-close pt-2 pt-md-0"
                            data-bs-dismiss="modal"
                            aria-label="Fermer"
                            style="display: block !important"
                        >
                            <span class="icon icon-delete" aria-hidden="true" />
                        </button>
                        <button
                            type="button"
                            class="btn-close ob1-link-arrow back"
                            data-bs-dismiss="modal"
                            style="display: none !important"
                        >
                            Fermer
                        </button>
                    </div>

                    <div class="modal-body">
                        <!-- Confirmation header : forfait added to cart + primary CTA -->
                        <div class="d-flex flex-column align-items-stretch gap-1 flex-md-row align-items-md-center justify-content-md-between">
                            <div class="d-flex align-items-center">
                                <div class="sim">
                                    <span
                                        class="icon-sim-check icon icon-tick-circle font-size-28"
                                        aria-hidden="true"
                                    />
                                    <img
                                        class="sim-img"
                                        :src="selectedOfferInfo ? selectedOfferInfo.offerImageUrl : ''"
                                        alt=""
                                    >
                                </div>
                                <div class="ms-1">
                                    <div
                                        :id="id + '-label'"
                                        class="mb-0 fw-bold text-dark"
                                    >
                                        {{ offerName }}
                                    </div>
                                    <span class="text-gray3 mb-0 py-0 font-size-14">
                                        {{ selectedOfferInfo ? selectedOfferInfo.offerInCartLabel : '' }}
                                    </span>

                                    <ob1-boutons
                                        v-if="isSub"
                                        class="d-md-none"
                                        :label="withoutDeviceSection.button.label"
                                        :is-button="false"
                                        :is-primary="!isSub"
                                        :is-secondary="isSub"
                                        :href="withoutDeviceSection.button.href"
                                        :data-oevent-category="withoutDeviceSection.button.tmsDTO.tagZone"
                                        :data-oevent-action="withoutDeviceSection.button.tmsDTO.tagName"
                                        :data-oevent-label="withoutDeviceSection.button.href"
                                    />
                                </div>
                            </div>
                            <ob1-boutons
                                v-if="isSub"
                                class="d-none d-md-block"
                                :label="withoutDeviceSection.button.label"
                                :is-button="false"
                                :is-primary="!isSub"
                                :is-secondary="isSub"
                                :href="withoutDeviceSection.button.href"
                                :data-oevent-category="withoutDeviceSection.button.tmsDTO.tagZone"
                                :data-oevent-action="withoutDeviceSection.button.tmsDTO.tagName"
                                :data-oevent-label="withoutDeviceSection.button.href"
                            />
                            <ob1-boutons
                                v-else
                                :label="withoutDeviceSection.button.label"
                                :is-button="false"
                                :is-primary="!isSub"
                                :is-secondary="isSub"
                                :href="withoutDeviceSection.button.href"
                                :data-oevent-category="withoutDeviceSection.button.tmsDTO.tagZone"
                                :data-oevent-action="withoutDeviceSection.button.tmsDTO.tagName"
                                :data-oevent-label="withoutDeviceSection.button.href"
                            />
                        </div>

                        <div class="col-12 pb-1" :class="isSub ? 'pt-1' : 'pt-2'">
                            <ob1-separateur color="gray4" />
                        </div>

                        <!-- Promo card : choose a device at a reduced price -->
                        <div class="promo-block d-flex bg-gray2">
                            <div class="px-md-2 px-1 pt-2">
                                <h4 class="text-dark" v-html="title" />
                                <ul class="mt-1 px-0">
                                    <li v-for="(advantage, index) in advantages" :key="index" class="font-size-14 mb-1 d-flex align-items-center">
                                        <span
                                            class="icon icon-checkbox-tick text-primary me-1"
                                            aria-hidden="true"
                                        />
                                        <span class="text-dark">
                                            <strong v-html="advantage" />
                                        </span>
                                    </li>
                                </ul>
                                <div class="d-flex justify-content-center d-lg-none">
                                    <img
                                        :src="visual.smallSrc"
                                        :alt="visual.alt"
                                    >
                                </div>
                            </div>
                            <div class="d-none d-lg-block">
                                <img
                                    :src="visual.src"
                                    :alt="visual.alt"
                                >
                            </div>
                        </div>

                        <div class="text-center pt-2">
                            <ob1-boutons
                                :label="withDeviceSection.button.label"
                                :is-button="false"
                                :is-primary="isSub"
                                :is-secondary="!isSub"
                                :href="withDeviceSection.button.href"
                                :data-oevent-category="withDeviceSection.button.tmsDTO.tagZone"
                                :data-oevent-action="withDeviceSection.button.tmsDTO.tagName"
                                :data-oevent-label="withDeviceSection.button.href"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: true,
        },
        offerName: {
            type: String,
            required: true,
        },
        advantages: {
            type: Array,
            required: true,
        },
        selectedOfferInfo: {
            type: Object,
            required: true,
        },
        visual: {
            type: Object,
            required: true
        },
        withDeviceSection: {
            type: Object,
            required: true
        },
        withoutDeviceSection: {
            type: Object,
            required: true
        },
        isSub: {
            type: Boolean,
            required: true,
        },
    },
    methods: {
        show() {
            // Le modal est rendu au sein de la tuile (ob1-cards / carrousel) : un modal
            // Bootstrap position:fixed imbriqué sous un ancêtre transformé est rogné et
            // n'apparaît pas. On le rattache donc à l'élément principal de la page avant
            // de l'ouvrir (même pattern que les tuiles accessoires).
            const target = $("[role='main']").length ? "[role='main']" : "body";
            $('#' + this.id).appendTo(target).modal('show');
        }
    }

}
</script>

<style scoped lang="scss">
@media (max-width: 767px) {
    .add-to-cart-popin-cds {
        padding-top: 110px !important;
    }

}
.btn-close::before {
    display: none !important;
}

.modal-dialog .modal-header {
    position: inherit !important;
}

.modal-dialog .modal-header.box-shadow {
    box-shadow: none !important;
}

.sim {
    position: relative;
    flex-shrink: 0;
    width: 80px;
}

.sim-img {
    display: block;
    width: 100%;
    height: auto;
}

.icon-sim-check {
    position: absolute;
    top: -2px;
    right: 4px;
    border-radius: 50%;
}

.promo-block {
    overflow: hidden;
}

</style>
